(() => {
  const expandedClass = 'moko-variant-options-expanded';
  const openClass = 'is-open';
  const htmlOpenClass = 'moko-variant-sheet-open';
  const desktopHtmlOpenClass = 'moko-variant-desktop-sheet-open';
  const expandedOptions = new Set();

  function getFieldsetKey(fieldset) {
    if (!fieldset) return '';
    const optionName = fieldset.dataset.mokoVariantOption;
    if (!optionName) return '';
    const variantPicker = fieldset.closest('variant-radios, variant-selects');
    const sectionId = variantPicker?.dataset.section || 'global';
    return `${sectionId}:${optionName}`;
  }

  function updateMoreButton(fieldset, isExpanded) {
    const moreButton = fieldset?.querySelector('[data-moko-variant-more]');
    if (!moreButton) return;

    moreButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    const label = moreButton.querySelector('span') || moreButton;
    label.textContent = isExpanded ? 'Show less' : 'View more';
  }

  function applyExpandedState(root = document) {
    if (!root?.querySelectorAll) return;

    root.querySelectorAll('.moko-variant-picker-overflow').forEach((fieldset) => {
      const key = getFieldsetKey(fieldset);
      const isExpanded = key ? expandedOptions.has(key) : fieldset.classList.contains(expandedClass);

      fieldset.classList.toggle(expandedClass, isExpanded);
      updateMoreButton(fieldset, isExpanded);
    });
  }

  function storeExpandedState() {
    document.querySelectorAll('.moko-variant-picker-overflow').forEach((fieldset) => {
      const key = getFieldsetKey(fieldset);
      if (!key) return;

      if (fieldset.classList.contains(expandedClass)) {
        expandedOptions.add(key);
      } else {
        expandedOptions.delete(key);
      }
    });
  }

  function registerProductInfo(productInfo) {
    if (!productInfo || productInfo.dataset.mokoVariantOverflowRegistered === 'true') return;
    if (typeof productInfo.addPreProcessCallback !== 'function') return;

    productInfo.addPreProcessCallback((newContent) => applyExpandedState(newContent));
    productInfo.dataset.mokoVariantOverflowRegistered = 'true';
  }

  function registerProductInfos(root = document) {
    if (!root?.querySelectorAll) return;
    root.querySelectorAll('product-info').forEach(registerProductInfo);
  }

  function updateSheetTrigger(sheet, isExpanded) {
    const trigger = sheet
      ?.closest('.moko-variant-picker-overflow')
      ?.querySelector('[data-moko-variant-sheet-open]');

    trigger?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  }

  function updateDesktopSheetTrigger(sheet, isExpanded) {
    const trigger = sheet
      ?.closest('.moko-variant-picker-overflow')
      ?.querySelector('[data-moko-variant-desktop-sheet-open]');

    trigger?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  }

  function closeDesktopSheet(sheet) {
    if (!sheet) return;
    updateDesktopSheetTrigger(sheet, false);
    sheet.classList.remove(openClass);
    window.setTimeout(() => {
      sheet.hidden = true;
      if (!document.querySelector('.moko-variant-desktop-sheet.is-open')) {
        document.documentElement.classList.remove(desktopHtmlOpenClass);
      }
    }, 240);
  }

  function openDesktopSheet(sheet) {
    if (!sheet) return;
    document.querySelectorAll('.moko-variant-desktop-sheet.is-open').forEach((openSheetElement) => {
      if (openSheetElement !== sheet) closeDesktopSheet(openSheetElement);
    });
    sheet.hidden = false;
    updateDesktopSheetTrigger(sheet, true);
    document.documentElement.classList.add(desktopHtmlOpenClass);
    window.requestAnimationFrame(() => sheet.classList.add(openClass));
  }

  function closeSheet(sheet) {
    if (!sheet) return;
    updateSheetTrigger(sheet, false);
    sheet.classList.remove(openClass);
    window.setTimeout(() => {
      sheet.hidden = true;
      if (!document.querySelector('.moko-variant-mobile-sheet.is-open')) {
        document.documentElement.classList.remove(htmlOpenClass);
      }
    }, 260);
  }

  function openSheet(sheet) {
    if (!sheet) return;
    sheet.hidden = false;
    updateSheetTrigger(sheet, true);
    document.documentElement.classList.add(htmlOpenClass);
    window.requestAnimationFrame(() => sheet.classList.add(openClass));
  }

  function updateFieldsetSelectedValue(input) {
    const fieldset = input.closest('.moko-variant-picker-overflow');
    if (!fieldset) return;

    const triggerValue = fieldset.querySelector('[data-moko-variant-selected]');
    if (triggerValue) {
      triggerValue.textContent = input.value;
    }
    fieldset.querySelectorAll('[data-moko-variant-selected]').forEach((valueNode) => {
      valueNode.textContent = input.value;
    });

    fieldset.querySelectorAll('[data-moko-variant-mobile-option]').forEach((option) => {
      option.classList.toggle('is-selected', option.dataset.targetInput === input.id);
    });

    fieldset.querySelectorAll('[data-moko-variant-desktop-option]').forEach((option) => {
      option.classList.toggle('is-selected', option.dataset.targetInput === input.id);
    });
  }

  document.addEventListener('click', (event) => {
    const moreButton = event.target.closest('[data-moko-variant-more]');
    if (moreButton) {
      const fieldset = moreButton.closest('.moko-variant-picker-overflow');
      if (!fieldset) return;

      const isExpanded = fieldset.classList.toggle(expandedClass);
      const key = getFieldsetKey(fieldset);
      if (key) {
        if (isExpanded) {
          expandedOptions.add(key);
        } else {
          expandedOptions.delete(key);
        }
      }
      updateMoreButton(fieldset, isExpanded);
      return;
    }

    const openDesktopButton = event.target.closest('[data-moko-variant-desktop-sheet-open]');
    if (openDesktopButton) {
      const fieldset = openDesktopButton.closest('.moko-variant-picker-overflow');
      openDesktopSheet(fieldset?.querySelector('[data-moko-variant-desktop-sheet]'));
      return;
    }

    const closeDesktopButton = event.target.closest('[data-moko-variant-desktop-sheet-close]');
    if (closeDesktopButton) {
      closeDesktopSheet(closeDesktopButton.closest('[data-moko-variant-desktop-sheet]'));
      return;
    }

    const desktopOptionButton = event.target.closest('[data-moko-variant-desktop-option]');
    if (desktopOptionButton) {
      const input = document.getElementById(desktopOptionButton.dataset.targetInput);
      if (!input) return;
      input.click();
      updateFieldsetSelectedValue(input);
      closeDesktopSheet(desktopOptionButton.closest('[data-moko-variant-desktop-sheet]'));
      return;
    }

    const openButton = event.target.closest('[data-moko-variant-sheet-open]');
    if (openButton) {
      const fieldset = openButton.closest('.moko-variant-picker-overflow');
      openSheet(fieldset?.querySelector('[data-moko-variant-sheet]'));
      return;
    }

    const closeButton = event.target.closest('[data-moko-variant-sheet-close]');
    if (closeButton) {
      closeSheet(closeButton.closest('[data-moko-variant-sheet]'));
      return;
    }

    const optionButton = event.target.closest('[data-moko-variant-mobile-option]');
    if (optionButton) {
      const input = document.getElementById(optionButton.dataset.targetInput);
      if (!input) return;
      input.click();
      updateFieldsetSelectedValue(input);
      closeSheet(optionButton.closest('[data-moko-variant-sheet]'));
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.moko-variant-picker-overflow .product-form__input__radio')) return;
    updateFieldsetSelectedValue(event.target);
  });

  document.addEventListener('optionValueSelectionChange', storeExpandedState);

  document.addEventListener('afterVariantChanged', (event) => {
    const productInfo = event.detail?.sectionId
      ? document.querySelector(`product-info[data-section="${event.detail.sectionId}"]`)
      : document;

    window.requestAnimationFrame(() => applyExpandedState(productInfo || document));
  });

  document.addEventListener('shopify:section:load', (event) => {
    registerProductInfos(event.target);
    applyExpandedState(event.target);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.moko-variant-desktop-sheet.is-open').forEach(closeDesktopSheet);
    document.querySelectorAll('.moko-variant-mobile-sheet.is-open').forEach(closeSheet);
  });

  registerProductInfos();
})();
